export default __webpack_public_path__ + "static/media/404.68ef6b93.jpg";